import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  DeviceFirstPage,
  ScanDevice,
  AllDevice,
  DeviceInfo,
  EndPage,
  WidgetsJoined,
} from "./";
import { DeviceSection } from "../../context/DeviceContext";

const DeviceOrg = () => {
  const { t } = useTranslation();
  const { devicePage } = useContext(DeviceSection);

  return (
    <>
      <div className="d-flex align-items-center weatherStatus mb-4">
        <i className="circleTop icon-plug text-center"></i>
        <div className="text-center mr-4">
          <p className="m-2">{t("اضافه کردن دستگاه")}</p>
        </div>
      </div>
      <div style={{ minHeight: "72vh" }} className="px-3">
        {devicePage.firstPage && <DeviceFirstPage />}
        {devicePage.scanDevice && <ScanDevice />}
        {devicePage.allDevices && <AllDevice />}
        {devicePage.deviceInfo && <DeviceInfo />}
        {devicePage.widgetsJoined && <WidgetsJoined />}
        {devicePage.endPage && <EndPage />}
      </div>
    </>
  );
};

export { DeviceOrg };
